import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { InfoTooltip } from '@/ui-kit/Tips/InfoTooltip';

import { View2FADetails } from '@/features/2fa/components/View2FADetails';
import { ISupportUser } from '@/features/dashboard-users/store/support-user.model';

export interface IDashboardUser2FAStatusProps {
  dashboardUser: ISupportUser;
  isFirstRow?: boolean;
  statusClassname?: string;
}

export function DashboardUser2FAStatus({
  dashboardUser,
  isFirstRow = false,
  statusClassname,
}: IDashboardUser2FAStatusProps) {
  const { t } = useTranslation();
  const { secureKey } = dashboardUser;
  const hasSecureKey = !!secureKey;

  return (
    <div className="flex justify-start items-center gap-2">
      <span
        className={twMerge(statusClassname, `typo-body-medium-caption ${hasSecureKey ? 'text-success' : 'text-error'}`)}
      >
        {hasSecureKey
          ? t('pages.administration.supportsUsers.table.status.2FA.value.enabled')
          : t('pages.administration.supportsUsers.table.status.2FA.value.disabled')}
      </span>
      {hasSecureKey && (
        <InfoTooltip
          tooltipInfo={<View2FADetails secureKey={secureKey} />}
          tooltipPlacement={isFirstRow ? 'bottom' : 'top'}
          infoClassName="max-w-[360px]"
        />
      )}
    </div>
  );
}
